import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, TextField, Button, IconButton, Collapse, Switch, Paper, Link, Checkbox, InputAdornment } from '@material-ui/core';
import { Dialog, DialogActions, DialogTitle, DialogContent } from '@material-ui/core/';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

import CloseIcon from '@material-ui/icons/Close';
import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';
import SelectList from '../Models/PickList/SelectList'
import { useLocation } from 'react-router-dom';
import queryString from 'query-string'
import {getUserRedirectUrl, getBannerSettings, signInUser,answerSelectMFAType,answerSMSMFA ,answerAuthAppMFA,answerEmailMFA,GetUser,answerResetPassword,writeauth,answerCustomSelectMFAType} from '../Services/authService';

import guardianloginportal from '../assets/Images/guardianloginportal.PNG'
import VerifyCodeDialog from './VerifyCodeDialog'
import MFASelectDialog from './MFASelectDialog'
import ForgotPassowrdDialog from './ForgotPassowrdDialog'
import ManageMFADialog from './ManageMFADialog'
import StatusDisplay from './StatusDisplay'
import ResetPasswordDialog from './ResetPasswordDialog'
import BannerComponent from './BannerComponent';
import BannerDialog from './BannerDialog'
import DevControls from './DevControls';

const drawerWidth = 0;

const useStyles = makeStyles((theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    appBarShift: {
        width: 800,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    },
    headerImage: {
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    rightSection: {

        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    titleBarDisplay: {
        backgroundColor: '#505759',
        color: '#fff',
    },

    logoutIcon: {
        color: '#fff',
        fontSize: '10px'
    },
    btnlogin: {
        marginRight: '20px',
        marginLeft: '20px',
    },
    portaldiv: {
        margin: 'auto',
        marginTop: 100,
        width: 800,
        height: 600,
        alignContent: 'center'
    },
    portalImgBox: {
        paddingLeft: 0,
        marginLeft: 0,
    },
    portalImgdiv: {
        width: 388,
        height: 600,
        float: 'left'
    },
    logindiv: {      
        width: 400,
        height: 600,
        paddingLeft: 0,
        marginLeft: 0,
        backgroundColor: '#FFF',
        float: 'left'
    },
    logoImg: {

    },
    commerceportallbl: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 22,
        color: "#1867B8",
        marginTop: 50,
    },
    usernamelbl: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 14,
        color: "#231F20",
        textAlign: 'left',
        paddingLeft: -150,
        marginBottom: 5
    },
    signinbtn: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 18,
        backgroundColor: "#1867B8",
        width: 160,
        height: 40,
        color: '#FFFFFF',
        margin: 20,
        borderRadius: 0,
        '&:hover': {
            backgroundColor: "#1867B8",
            color: '#FFFFFF',
        }

    },
    forgotpasswordlbl: {
        fontFamily: 'Open Sans',
        fontWeight: 400,
        fontSize: 14,
        color: "#A3A39E",
    },
    txtboxInput: {
        height: 10
    }
}));

const Login = () => {
    const classes = useStyles();
    const { search } = useLocation()
    let [bannerResult, setbannerResult] = useState('');
    const [bannerMessage, setBannerMessage] = useState('');
    let [successMessage, setsuccessMessage] = useState('');
    let [errorMessage, seterrorMessage] = useState('');
    let [language, setlanguage] = useState(localStorage.getItem('userlangugae'));
    let [isRunning, setIsRunning] = useState(false);

    let [username, setUsername] = useState();
    let [password, setPassword] = useState();
    let [manageMFA, setManageMFA] = useState(false);
    let [cognitoResult, setCognitoResult] = useState();
    let [authInfo, setAuthInfo] = useState();
    let [userInfo, setUserInfo] = useState();
    let [redirect_uri, setRedirect_uri] = useState();
    let [state, setState] = useState();
    let [clientId, setClientId] = useState();
    let [session, setSession] = useState();
    const sessionRef = useRef(); // Use ref to ensure immediate access to latest session

    let [signinlabel, setsigninlabel] = useState(SelectList.GetTranslations('en'));

    let [openBannerDialog, setOpenBannerDialog] = useState(false);
    let [open_sms, setOpenSMS] = useState(false);
    let [open_authapp, setOpenAuthApp] = useState(false);
    let [open_email, setOpenEmail] = useState(false);
    let [open_choose, setOpenChoose] = useState(false);
    let [openForgotPassword, setOpenForgotPassword] = useState(false);
    let [openResetPassword, setOpenResetPassword] = useState(false);
    let [openManageMFA,setOpenManageMFA]= useState(false);
    const [loginPhase, setLoginPhase] = useState(1);
    const [loginUser, setLoginUser] = useState(localStorage.getItem('phaseTwoData') || null);
    const [loginPassword, setLoginPassword] = useState(null);
    const [showDevControls, setShowDevControls] = useState(false);
    const [localDev, setLocalDev] = useState(false);

    let mfaRequired = ( process.env.REACT_APP_FORCEMFA === "true")?true:false
    const environment = process.env.REACT_APP_HOST_VARIABLE;
    
    // Facilitate a dual-phase login process (M3 or Legacy instance of Salesforce):
    // 1. User enters username and clicks "Next". We store the username in local storage so we can retrieve it later.
    // 2. We will check the user's group assignments in Cognito to determine which instance of Salesforce they will be routed to.
    // 3. Then we redirect the user to Salesforce to initiate SSO and obtain the state value.
    // 4. Salesforce redirects the user back here, where we retrieve the username from local storage and ask for the password

    useEffect(() => {

        console.log("Application Version ", process.env.REACT_APP_VERSION);

        var selectedLanguge = localStorage.getItem('userlangugae');
        var convertedLanguage = SelectList.GetConvertedLangCode(selectedLanguge);
        console.log(`Language preference '${selectedLanguge}' detected, using locale settings for '${convertedLanguage}'`);

        // check if query paramters have locale (language)
        const newUserQueryParams = queryString.parse(search)
        if (newUserQueryParams && newUserQueryParams.locale ) {
            selectedLanguge = newUserQueryParams.locale;
            localStorage.removeItem('userlangugae');
            localStorage.setItem('userlangugae', selectedLanguge);
        }else if(!selectedLanguge){
            selectedLanguge = 'en';
        }
        setlanguage(selectedLanguge);
        setsigninlabel(SelectList.GetTranslations(selectedLanguge));
        
    }, [language,mfaRequired,search])

    useEffect(() => {
        if(localStorage.getItem('phaseTwoStarting')){
            const storedUser = localStorage.getItem('phaseTwoData');
            setLoginPhase(2);
            const values = queryString.parse(window.location.search);
            
            // Check if we have banner information for this user
            if(bannerResult.AllowLogin === undefined){ // We don't know if there's a banner yet
                getUserBannerSettings(storedUser).then(result => {
                    validateClientState(values, storedUser);
                });
            }else{  // We have a banner result
                if(bannerResult.AllowLogin){ // Banner exists, AllowLogin is true
                    validateClientState(values);
                }
            }
        }else{ // Assume we're in Login Phase 1
            if(bannerResult.AllowLogin === undefined){ // We don't know if there's a banner yet
                getUserBannerSettings();
            }
        }

        // Support for local development
        if(environment === "development"){
            setShowDevControls(true);
            if(localDev && window.location.hostname !== "localhost"){
                handleLocalhostRedirect();
            }
        }

    }, []);

    useEffect(() => {
        // This hook will run when bannerResult is updated. 
        // It will display the banner as information or as a modal, depending on the value of AllowLogin

        if(bannerResult.AllowLogin === false){ // The user cannot login, show the banner modal
            setBannerMessage(formatBannerMessageForDisplay());
            setOpenBannerDialog(true);
        }
        if(bannerResult.AllowLogin === true){ // A banner exists but login is allowed, show the info notification
            setBannerMessage(formatBannerMessageForDisplay());
        }
    }, [bannerResult]);

    const validateClientState = (values, storedUser) => {
        if(!values.state){ // we don't have state
            console.warn("Warning: authentication was not properly initialized, redirecting to client.");
            initiateClientSSO(storedUser);                       
        }else{ // we have state and AllowLogin is true
            setRedirect_uri(values.redirect_uri);
            setState(values.state);
            setClientId(values.client_id);
        }
    }
    const toggleDevControls = () => {
        if(localDev){ // We're turning off local dev mode
            console.log("Local Dev Mode: OFF");
            localStorage.removeItem('loginDomain');
            setLocalDev(!localDev);
        }else{ // We're turning on local dev mode
            if(window.location.hostname !== "localhost"){
                console.log("Local Dev Mode can only be enabled from localhost.");
            }else{
                console.log("Local Dev Mode: ON");
                const domain = window.location.hostname;
                const port = window.location.port;
                localStorage.setItem('loginDomain', domain + ":" + port);
                setLocalDev(!localDev);
            }
        }
    }
    const handleError=(code,error)=>{
        console.error(`Error encountered! Code: ${code}`);
        if(error){
            console.error('Error object:', JSON.stringify(error.response?.data || error, null, 2));
        }
        if ( code && signinlabel.ErroMessages[code]) {
            seterrorMessage( signinlabel.ErroMessages[code] );    
        }else if (error.response && error.response.data && error.response.data.InnerException && error.response.data.InnerException.ErrorCode && signinlabel.ErroMessages[ error.response.data.InnerException.ErrorCode ]){
            // Check InnerException.ErrorCode FIRST - it's more specific than the outer Error field
            seterrorMessage( signinlabel.ErroMessages[ error.response.data.InnerException.ErrorCode ] );
        }else if (error.response && error.response.data && error.response.data.Error && signinlabel.ErroMessages[error.response.data.Error]){
            seterrorMessage( signinlabel.ErroMessages[error.response.data.Error] );
        }else if (error.response && error.response.data && error.response.data.InnerException && error.response.data.InnerException.Message && signinlabel.ErroMessages[ error.response.data.InnerException.Message ]){
            seterrorMessage( signinlabel.ErroMessages[ error.response.data.InnerException.Message ] );
        }else if(error.response && error.response.data && error.response.data.InnerException && error.response.data.InnerException.Message){
            seterrorMessage(error.response.data.InnerException.Message);
        }else if(error.response && error.response.data && error.response.data.InnerException && error.response.data.InnerException.ErrorCode){
            seterrorMessage(error.response.data.InnerException.ErrorCode);
        }else if(error && error.message){
            seterrorMessage(error.message);
        } else{
            seterrorMessage(signinlabel.ErroMessages.InternalErrorException);
        }
    }
    const handleSignIn = (pwd) => {
        // Prevent duplicate submissions
        if (isRunning) {
            console.log('Sign-in already in progress, ignoring duplicate call');
            return;
        }
        
        const enteredPwd = typeof pwd == 'string' ? pwd : loginPassword;
  
        //if we are forcing a signin after force MFA
        if(authInfo){
            authInfo = null; setAuthInfo(authInfo);
        }

        if(loginPhase == 2){
            seterrorMessage("");
            setUsername(loginUser);
            setPassword(enteredPwd);
            username=loginUser;
            password=enteredPwd;
            if ( !username  || !password) {
                handleError("ValidateUserNameAndPassword");
                // Login failed, clean up local storage:
                localStorage.removeItem('phaseTwoData'); 
                localStorage.removeItem('phaseTwoStarting'); 
            }else if (/\s/g.test(username)) {
                handleError("InvalidUsername");
                // If username isn't valid, remove it from local storage:
                localStorage.removeItem('phaseTwoData');
            }else if (!redirect_uri) {
                handleError("Error: please reset login form and try again.");
                // If redirect_uri isn't valid, user must start over from clean login
                // if this persists contact support (SF config problem)
                localStorage.removeItem('phaseTwoData');
            }else if( authInfo ){
                handleCognitoResult();
            }else{
                setIsRunning(true);
                signInUser(username, password, redirect_uri, state ).then(result => {
                    cognitoResult = result; setCognitoResult(result);
                    handleCognitoResult();
                    // Login process should succeed now, clean up local storage:
                    localStorage.removeItem('phaseTwoData'); 
                    localStorage.removeItem('phaseTwoStarting'); 
                }).catch(err=>{
                    handleError(null,err);
                }).finally(()=>{
                    setIsRunning(false);
                });
            }
        }
    }
    const getUserBannerSettings = (username) => {
        // Checks for a banner for the provided username. 
        // Returns TRUE if BannerMessageKey is not empty.
        setIsRunning(true);
        console.log(username ? "Fetching banner settings for user: " + username : "Fetching global banner settings");
        return new Promise((resolve, reject) => {
            getBannerSettings(username).then(result => {
                const bannerSettings = result.data;
                if(bannerSettings.BannerMessageKey !== undefined && bannerSettings.BannerMessageKey !== ""){
                    setbannerResult(bannerSettings);
                    console.log("Retrieved banner settings: ", bannerSettings);
                }
                resolve(bannerSettings.data);
            }).catch(err=>{
                console.log("An error occurred while fetching banner settings: ", err);
                // If we cannot tell if there is a banner in place, we should allow login
                resolve(false);
            }).finally(()=>{
                setIsRunning(false);
            });  
        }); 
    }
    const handleSSO = (user) => {
        seterrorMessage("");
        let enteredUser = user ? user : loginUser;
        if (!enteredUser) {
            enteredUser = document.getElementById('txtusername').value;
        }

        // Store the username for future sessions
        localStorage.setItem('phaseTwoData', enteredUser);
        setLoginUser(enteredUser);
        initiateClientSSO(enteredUser);
    }
    const initiateClientSSO = (user) => {
        getUserRedirectUrl(user).then(result => {
            localStorage.setItem('phaseTwoStarting', 2);
            console.log("Redirecting to client to obtain state: " + result.data.RedirectUrl);
            window.location.href = result.data.RedirectUrl;
        }).catch(err=>{
            console.error("An error occurred while looking up the specified user.", err);
            handleError(null,err);
            // Login failed, clean up local storage:
            localStorage.removeItem('phaseTwoData'); 
            localStorage.removeItem('phaseTwoStarting'); 
        }); 
    }
    const findInArray= (arr,key,value)=>{
        for(var i=0;i<arr.length;i++){
            if(arr[i][key]===value) return arr[i];
        }
        return null;
    };
    const handleCognitoResult=()=>{
        if(cognitoResult.data.Session){
            session =cognitoResult.data.Session; setSession(session);
            sessionRef.current = session;
            console.log('Updated session from Cognito result (first 50 chars):', session.substring(0, 50));
        } 
        if(cognitoResult.data.SessionId){
            session =cognitoResult.data.SessionId; setSession(session);
            sessionRef.current = session;
            console.log('Updated session from SessionId (first 50 chars):', session.substring(0, 50));
        } 
        if(cognitoResult.data.AuthenticationResult){
             authInfo = cognitoResult;setAuthInfo(cognitoResult);
            handleDialogClose();
            handleLoadUserInfo().then(()=>{
                var customMFA = (userInfo)? findInArray(userInfo.data.UserAttributes,"Name","custom:mfapreference"):null;
                if( manageMFA || ( !customMFA && mfaRequired ) ){
                    setOpenManageMFA(true);
                }else{ //If we didn't open the MFA dialog we can login to salesforce.
                    handleWriteAuth();
                }
            });
        }else if(cognitoResult.data.ChallengeName === "SELECT_MFA_TYPE" || cognitoResult.data.ChallengeName.Value === "SELECT_MFA_TYPE" ){
            handleDialogClose();
            setOpenChoose(true);
        }else if(cognitoResult.data.ChallengeName === "SMS_MFA" || cognitoResult.data.ChallengeName.Value === "SMS_MFA"){
            if (!open_sms) {
                // Only close/open if we're switching to SMS from another challenge
                handleDialogClose();
            }
            setOpenSMS(true); 
        }else if(cognitoResult.data.ChallengeName === "NEW_PASSWORD_REQUIRED" || cognitoResult.data.ChallengeName.Value === "NEW_PASSWORD_REQUIRED"){
            handleDialogClose();
            setOpenResetPassword(true);
        }else if(cognitoResult.data.ChallengeName === "SOFTWARE_TOKEN_MFA" || cognitoResult.data.ChallengeName.Value === "SOFTWARE_TOKEN_MFA"){
            if (!open_authapp) {
                // Only close/open if we're switching to AuthApp from another challenge
                handleDialogClose();
            }
            setOpenAuthApp(true);            
        }else if(cognitoResult.data.ChallengeName ==="CUSTOM_CHALLENGE" || cognitoResult.data.ChallengeName.Value ==="CUSTOM_CHALLENGE" ){
            if (!open_email) {
                // Only close/open if we're switching to Email MFA from another challenge
                handleDialogClose();
            }
            setOpenEmail(true);            
        }
    };
    const handleWriteAuth = ()=>{
        setIsRunning(true);
        writeauth(username,authInfo.data.AuthenticationResult).then(result => {
            setsuccessMessage( signinlabel.SuccessMessage);
            // var url = (redirect_uri)?redirect_uri:process.env.REACTx_APPx_SALESFORCEx_URLx;
            var url = redirect_uri
            url = url+`?code=${result.data.code?result.data.code:""}`
            url = url+`&state=${state?state:""}`
            console.log("** redirecting to url=" + url);
            window.location.href = url;
        }).catch(error => {
            handleError(null,error);
        }).finally(()=>{
            setIsRunning(false);
        });
    };
     const handleLoadUserInfo = ()=>{
         seterrorMessage("");
         setIsRunning(true);
         return GetUser(authInfo.data.AuthenticationResult.AccessToken).then(result=>{
             userInfo = result;setUserInfo(result);
         }).catch(error=>{
             handleError(null,error);
         }).finally(()=>{ 
             setIsRunning(false);                
         });
     }
    const handleMFASelect = ( answer ) =>{
        seterrorMessage("");
        console.log("Select MFA: "+answer);
        setIsRunning(true);
        if(cognitoResult && cognitoResult.data && cognitoResult.data.ChallengeName && cognitoResult.data.ChallengeName.Value && cognitoResult.data.ChallengeName.Value === "CUSTOM_CHALLENGE" ){
            answerCustomSelectMFAType(username, answer,session,clientId).then(result=>{
                cognitoResult = result;
                setCognitoResult(result);
                handleCognitoResult();
            }).catch((error)=>{
                handleError(null,error);
            }).finally(()=>{
                setIsRunning(false);
            });
        }else{
            answerSelectMFAType(username, answer,session,clientId).then(result=>{
                cognitoResult = result;
                setCognitoResult(result);
                handleCognitoResult();
            }).catch((error)=>{
                handleError(null,error);
            }).finally(()=>{
                setIsRunning(false);
            });    
        }
        
    };
    const handleAuthAppChallenge = (answer) => {
        if (!answer || answer.trim() === '') {
            return; // Don't submit empty code
        }
        seterrorMessage("");
        console.log("Auth App1 MFA: "+answer);
        const currentSession = sessionRef.current || session;
        console.log('Using session (first 50 chars):', currentSession?.substring(0, 50));
        setIsRunning(true);
        answerAuthAppMFA(username, answer,currentSession,clientId).then(result=>{
            cognitoResult = result;
            setCognitoResult(result);
            handleCognitoResult();
        }).catch((error)=>{
            // Preserve session from error response to allow retry
            if (error.response && error.response.data && error.response.data.Session) {
                const newSession = error.response.data.Session;
                console.log('AuthApp MFA failed - preserving new session (first 50 chars):', newSession.substring(0, 50));
                session = newSession;
                setSession(newSession);
                sessionRef.current = newSession;
            }
            handleError(null,error);
        }).finally(()=>{
            setIsRunning(false);
        });        
    };
    const handleEmailChallenge = (answer) => {
        if (!answer || answer.trim() === '') {
            return; // Don't submit empty code
        }
        seterrorMessage("");
        console.log("Email MFA: "+answer);  // adding comment to trigger build cuz it doesn't seem like this is deployed.
        const currentSession = sessionRef.current || session;
        console.log('Using session (first 50 chars):', currentSession?.substring(0, 50));
        setIsRunning(true);
        answerEmailMFA(username, answer,currentSession,clientId).then(result=>{
            cognitoResult = result;
            setCognitoResult(result);
            handleCognitoResult();
        }).catch((error)=>{
            // Preserve session from error response to allow retry
            if (error.response && error.response.data && error.response.data.Session) {
                const newSession = error.response.data.Session;
                console.log('Email MFA failed - preserving new session (first 50 chars):', newSession.substring(0, 50));
                session = newSession;
                setSession(newSession);
                sessionRef.current = newSession;
            }
            handleError(null,error);
        }).finally(()=>{
            setIsRunning(false);
        });        
    };
    const handleForgotPassowrdDialogClose = (newpwd) => {
        setLoginPassword(newpwd);
        handleDialogClose();
        
    }
    const handleDialogClose = (writeAuth) => {
        seterrorMessage("");
        setOpenForgotPassword(false);
        setOpenAuthApp(false);
        setOpenSMS(false); 
        setOpenEmail(false); 
        setOpenChoose(false);
        setOpenManageMFA(false);
        setOpenResetPassword(false);
        if(writeAuth) {
            var customMFA = (userInfo)? findInArray(userInfo.data.UserAttributes,"Name","custom:mfapreference"):null;
            if(!customMFA && mfaRequired){
                setManageMFA(false); manageMFA = false;
                handleSignIn();
            }else{
                handleWriteAuth();
            }
        };
    };
    const handleNewResetPassword = (newPass,newPass1) => {
        seterrorMessage("");
        if(newPass && newPass === newPass1){
            setIsRunning(true);
            answerResetPassword(username, newPass,session,clientId).then(result=>{

                document.getElementById('txtpassword').value = newPass;
                //the form will be re-submitted for login with the new password
                setPassword(newPass);
                setLoginPassword(newPass);
                cognitoResult = result;
                setCognitoResult(result);
                handleCognitoResult();
            }).catch((error)=>{
                handleError(null,error);
            }).finally(()=>{
                setIsRunning(false);
            });       
        }else{
            handleError("ConfirmPasswordNotMatchException");
        }
    };
    const handleSMSChallenge = (usercode) => {
        if (!usercode || usercode.trim() === '') {
            return; // Don't submit empty code
        }
        seterrorMessage("");
        const currentSession = sessionRef.current || session;
        console.log('Using session (first 50 chars):', currentSession?.substring(0, 50));
        setIsRunning(true);
        answerSMSMFA(loginUser,usercode,currentSession,clientId).then( result => {
            cognitoResult= result;
            setCognitoResult(result);
            handleCognitoResult();
        }).catch(error => {
            // Preserve session from error response to allow retry
            if (error.response && error.response.data && error.response.data.Session) {
                const newSession = error.response.data.Session;
                console.log('SMS MFA failed - preserving new session (first 50 chars):', newSession.substring(0, 50));
                session = newSession;
                setSession(newSession);
                sessionRef.current = newSession;
            }
            handleError(null,error);
        }).finally(()=>{
            setIsRunning(false);
        });

    };
    const formatBannerMessageForDisplay = () => {
        
        let message = signinlabel[bannerResult.BannerMessageKey];
        
        if(bannerResult.BannerMessageKey !== undefined && bannerResult.BannerMessageKey!== ""){
           
            //message = signinlabel[bannerResult.BannerMessageKey];
            if (!message) {
                console.log("Banner message key not found: ", bannerResult.BannerMessageKey);
                return "There was a problem with the banner message. Please contact support.";
            }
            
            const options = {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                timezone: "UTC",
                hour: "numeric",
                minute: "numeric",
                //second: "numeric"
            };

            var convertedLanguage = SelectList.GetConvertedLangCode(language); //the LocalString dates below need BCP 47 codes

            let startdateutc = new Date(bannerResult.StartDateUTC);
            let startDateLocalString = startdateutc.toLocaleString(convertedLanguage, options);
            message = message.replace('@startdate', startDateLocalString);

            let enddateutc = new Date(bannerResult.EndDateUTC)
            let endDateLocalString = enddateutc.toLocaleString(convertedLanguage, options);
            message = message.replace('@enddate', endDateLocalString);
            
            let diffhours = (enddateutc.getTime() - startdateutc.getTime()) / 1000 / 60 / 60;
            let duration = Math.abs(Math.round(diffhours));
            message = message.replace('@outagewindowhours', duration)

            //add breaks
            message = message.replace("||", "<br/>");

            //handle hyperlinks
            //change 
            //...Please contact <a>support.usca@guardian.com</a> for orders...
            //to
            //...Please contact <a href="support.usca@guardian.com" target="_blank" rel="noopener noreferrer">support.usca@guardian.com</a> for orders...
            //NOTE there can be multiple hyperlinks in the message

            //NOTE use <email> for email links and <a> for web links
            
            let start = message.indexOf("<a>");
            let end = message.indexOf("</a>");
            while (start !== -1 && end !== -1) {
                let link = message.substring(start + 3, end);
                let newLink = `<a href="${link}" target="_blank" rel="noopener noreferrer">${link}</a>`;
                message = message.substring(0, start) + newLink + message.substring(end + 4);
                start = message.indexOf("<a>", end + 4);
                if (start === -1){
                    break;
                }
                end = message.indexOf("</a>", start + 3);
            }

            start = message.indexOf("<email>");
            end = message.indexOf("</email>");
            while (start !== -1 && end !== -1) {
                let link = message.substring(start + 7, end);
                let newLink = `<a href="mailto:${link}">${link}</a>`;
                message = message.substring(0, start) + newLink + message.substring(end + 8);
                start = message.indexOf("<email>", end + 8);
                if (start === -1){
                    break;
                }
                end = message.indexOf("</email>", start + 7);
            }
        }

        return message;
    };
    const handleForgotPassword = () => {
        handleDialogClose();
        setOpenForgotPassword(true);
    }
    const handleClearLoginForm = (e) => {
        // Clean up local storage:
        localStorage.removeItem('phaseTwoData'); 
        localStorage.removeItem('phaseTwoStarting');
        console.log("Cleared local storage, restart login");
        if(e.shiftKey){ // If shift key was pressed, clear the domain cookie
            localStorage.removeItem('loginDomain');
        }
        window.location.reload();
        //TODO: Clear the form properly
    }
    const handleLocalhostRedirect = () => {
        if(environment === "development"){
            const storedDomain = localStorage.getItem('loginDomain');
            const loginDomain = storedDomain ? storedDomain : "localhost:8200";
            const newURL = loginDomain + window.location.pathname + window.location.search;
            console.log("Redirecting to: " + newURL);
            window.location.href = "http://" + newURL;
        }
    }
    return (
        <div className={classes.portaldiv}>
            {environment === "development" && (
                <DevControls 
                    devMode={localDev} 
                    toggleDevModeHandler={toggleDevControls}
                    handleLocalhostRedirect={handleLocalhostRedirect}                
                />
            )}
            {bannerResult.BannerMessageKey !== undefined && bannerResult.BannerMessageKey !== "" && openBannerDialog === false && (
                // showing the banner component only if there is a banner key returned
                <Grid container justify="center" style={{ marginBottom: '1rem' }}>
                    <Paper className={classes.paper} elevation={3}>
                        <BannerComponent 
                            bannerMessage={bannerMessage}
                            bannerWidth="100%"
                        >
                        </BannerComponent>
                    </Paper>
                </Grid>
            )}
            <Grid container>
                <Paper className={classes.paper} elevation={5}>
                    <div className={classes.portalImgdiv}>
                        <Box ml={1} className={classes.portalImgBox}>
                            <img src={guardianloginportal} alt="" className={classes.logoImg}  ></img>
                        </Box>
                    </div>
                    <div className={classes.logindiv}>
                        <Grid container justify="center" >
                            <div style={{ paddingTop: '10px', width: '400px' }}>
                                <div>  <h4 className={classes.commerceportallbl} >{signinlabel.LogInLabels}</h4></div>
                            </div>
                        </Grid>
                        <Grid container justify="center">
                            <Grid style={{ padding: '10px', width: '400px' }}>
                                <StatusDisplay isRunning={isRunning} successMessage={successMessage} setSuccessMessage={setsuccessMessage} error={errorMessage} setError={seterrorMessage} ></StatusDisplay>    
                            </Grid>
                            <Grid container justify="center">
                                <div>
                                    <Grid item xs={6} style={{ paddingTop: '5x', marginLeft: '75px' }}>
                                        <div className={classes.usernamelbl}>
                                            <label>{signinlabel.UserNameLabels}</label>
                                            <label style={{ color: '#1867B8', paddingBottom: '25px' }}>*</label>
                                        </div>
                                        <TextField id="txtusername" 
                                            defaultValue={loginUser} 
                                            name="txtusernamesignin" 
                                            variant="outlined" 
                                            type="text"
                                            onBlur={e=>{setLoginUser(e.target.value);} }
                                            onKeyDown={e=>{if (e.key === 'Enter') {
                                                setLoginUser(e.target.value);
                                                handleSSO(e.target.value);
                                                }} }
                                            style={{ width: '250px', marginBottom: '10px' }} 
                                            InputProps={{
                                                endAdornment: 
                                                    <InputAdornment position="end" style={{cursor: 'pointer'}}>
                                                        {loginUser &&
                                                        <div onClick={(e)=>{handleClearLoginForm(e)}}>x</div>
                                                        }&nbsp;
                                                    </InputAdornment>,
                                                classes: { input: classes.txtboxInput } }
                                            } 
                                            disabled = {loginPhase == 2}
                                            /> <br></br>
                                        
                                        {loginPhase == 2 && <>
                                            <div className={classes.usernamelbl}>
                                                <label>{signinlabel.PasswordLabels}</label>
                                                <label style={{ color: '#1867B8', paddingBottom: '25px' }}>*</label>
                                            </div>
                                            <TextField id="txtpassword" 
                                                name="txtpasswordsignin" 
                                                variant="outlined" 
                                                type="password"
                                                autoFocus 
                                                onBlur={e=>{setLoginPassword(e.target.value);}}
                                                onKeyDown={e=>{if (e.key === 'Enter') {
                                                    setLoginPassword(e.target.value);
                                                    handleSignIn(e.target.value);
                                                  }} }
                                                style={{ width: '250px', marginBottom: '10px' }} InputProps={{ classes: { input: classes.txtboxInput } }} 
                                            />
                                            <div>{signinlabel.MANAGE_MFA} <Checkbox id="manageMFA" name="manageMFA" checked={manageMFA} onChange={e=>{setManageMFA(e.target.checked);}}  ></Checkbox></div>
                                            <br/>
                                            <Button variant="contained" color="primary" onClick={handleSignIn} disabled={isRunning} className={classes.signinbtn}> {signinlabel.SignInLabels} </Button>
                                        </>}
                                        {loginPhase == 1 && <>
                                            <Button variant="contained" color="primary" onClick={(e)=>handleSSO()} className={classes.signinbtn}> {signinlabel.NextButtonLabels} </Button>
                                        </>}
                                        <Link component="button" onClick={handleForgotPassword} style={{ marginLeft: '30px' }}> {signinlabel.ForgotPasswordLabels} </Link>
                                    </Grid>
                                </div>
                            </Grid>
                            <BannerDialog 
                                open={openBannerDialog}
                                title={signinlabel.BannerImportantMessageTitle} 
                                message={bannerMessage} 
                                buttonlabel="OK" 
                                allowlogin={bannerResult.AllowLogin} >
                            </BannerDialog>
                            <VerifyCodeDialog open={open_sms} okCallback={handleSMSChallenge} closeCallback={handleDialogClose}
                                title={signinlabel.VerifyUserTitle} 
                                message={signinlabel.MFASMSInformation.replace('@phonenumber',(cognitoResult && cognitoResult.data && cognitoResult.data.ChallengeParameters && cognitoResult.data.ChallengeParameters.CODE_DELIVERY_DESTINATION)?cognitoResult.data.ChallengeParameters.CODE_DELIVERY_DESTINATION:"" )} 
                                buttonlabel={signinlabel.SignInLabels} 
                                isRunning={isRunning} successMessage={successMessage} setSuccessMessage={setsuccessMessage} error={errorMessage} setError={seterrorMessage} >
                            </VerifyCodeDialog>
                            <VerifyCodeDialog open={open_authapp} signinlabel={signinlabel} okCallback={handleAuthAppChallenge} closeCallback={handleDialogClose}
                                title={signinlabel.VerifyUserTitle} message={signinlabel.MFAAuthAppInformation} buttonlabel={signinlabel.SignInLabels} 
                                isRunning={isRunning} successMessage={successMessage} setSuccessMessage={setsuccessMessage} error={errorMessage} setError={seterrorMessage} >
                            </VerifyCodeDialog>
                            <VerifyCodeDialog open={open_email} signinlabel={signinlabel} okCallback={handleEmailChallenge} closeCallback={handleDialogClose}
                                title={signinlabel.VerifyUserTitle} message={signinlabel.SelectEmailDescription} buttonlabel={signinlabel.SignInLabels} 
                                isRunning={isRunning} successMessage={successMessage} setSuccessMessage={setsuccessMessage} error={errorMessage} setError={seterrorMessage} >
                            </VerifyCodeDialog>
                            <MFASelectDialog open={open_choose} signinlabel={signinlabel} okCallback={handleMFASelect} closeCallback={handleDialogClose} cognitoResult={cognitoResult} 
                                isRunning={isRunning} successMessage={successMessage} setSuccessMessage={setsuccessMessage} error={errorMessage} setError={seterrorMessage}> 
                            </MFASelectDialog>
                            <ForgotPassowrdDialog user={loginUser} open={openForgotPassword} signinlabel={signinlabel} closeCallback={handleForgotPassowrdDialogClose} clientId={clientId}
                                isRunning={isRunning} setIsRunning={setIsRunning} successMessage={successMessage} setSuccessMessage={setsuccessMessage} error={errorMessage} setError={seterrorMessage}
                                handleError={handleError}> 
                            </ForgotPassowrdDialog>
                            <ManageMFADialog open={openManageMFA} userInfo={userInfo} username={username} signinlabel={signinlabel} closeCallback={handleDialogClose}  authInfo={authInfo}
                                isRunning={isRunning} setIsRunning={setIsRunning} successMessage={successMessage} setSuccessMessage={setsuccessMessage} error={errorMessage} setError={seterrorMessage}
                                handleError={handleError}>
                            </ManageMFADialog>
                            <ResetPasswordDialog open={openResetPassword} signinlabel={signinlabel} okCallback={handleNewResetPassword} closeCallback={handleDialogClose} 
                                isRunning={isRunning} setIsRunning={setIsRunning} successMessage={successMessage} setSuccessMessage={setsuccessMessage} error={errorMessage} setError={seterrorMessage}>
                            </ResetPasswordDialog>
                        </Grid>
                    </div>
                </Paper>
            </Grid>
        </div>
    )
}

export default Login
